import React from "react";
import { Reveal } from "@/components/motion/Reveal";
import { ASSETS } from "@/data/content";
import { useI18n } from "@/i18n";
import { Download, Bike, Footprints, Activity, Compass, Baby } from "lucide-react";

const ICONS = [Bike, Footprints, Activity, Compass, Baby];

export const GuideDownload = ({ testid = "guide-download" }) => {
  const { t, site } = useI18n();
  const g = t.guide;
  const chips = g.chips.map((label, i) => ({ label, icon: ICONS[i] }));

  return (
    <section
      data-testid={`${testid}-section`}
      className="relative bg-ink text-canvas py-14 md:py-20 overflow-hidden"
    >
      <img
        src={ASSETS.surrRiver}
        alt=""
        aria-hidden="true"
        className="absolute inset-0 w-full h-full object-cover opacity-15"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-ink via-ink/90 to-ink" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-8 md:gap-16 items-center">
          <div className="col-span-12 lg:col-span-7">
            <Reveal>
              <p className="overline text-canvas/60 mb-6">{g.overline}</p>
              <h2 className="serif text-3xl md:text-4xl lg:text-5xl font-light leading-[1.1] tracking-tight text-canvas [text-wrap:pretty]">
                {g.headingA} <em className="italic text-brand-red">{g.name}</em> {g.headingB}
              </h2>
              <p className="mt-8 text-canvas/70 text-base md:text-lg leading-relaxed max-w-xl [text-wrap:pretty]">
                {g.bodyPre} <em className="italic text-canvas">{g.nameLoc}</em> {g.bodyPost}
              </p>

              <div className="mt-8 flex flex-wrap gap-x-8 gap-y-4">
                {chips.map((r) => (
                  <div key={r.label} className="flex items-center gap-3 text-canvas/80">
                    <r.icon size={18} strokeWidth={1.3} className="text-brand-red" />
                    <span className="text-sm tracking-wide">{r.label}</span>
                  </div>
                ))}
              </div>
            </Reveal>
          </div>

          <div className="col-span-12 lg:col-span-5 lg:flex lg:justify-end">
            <Reveal delay={0.15}>
              <a
                href={site.guidePdf}
                download
                data-testid={`${testid}-button`}
                className="group inline-flex items-center gap-4 bg-brand-red/80 hover:bg-brand-red/90 text-canvas px-8 py-5 transition-colors duration-500"
              >
                <Download
                  size={22}
                  strokeWidth={1.3}
                  className="shrink-0 group-hover:-translate-y-0.5 transition-transform duration-500"
                />
                <span className="text-xs tracking-[0.3em] uppercase">
                  {g.button}{" "}
                  <em className="italic normal-case tracking-normal text-sm">
                    {g.name}
                  </em>{" "}
                  {g.buttonSuffix}
                </span>
              </a>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GuideDownload;
